import { JSONObject } from "../services";

/**
 * Utility class for JSON formatting and parsing operations
 */
export class JsonFormatter {
  private static readonly INDENT_SPACES = 2;
  private static readonly HTML_ESCAPES: Record<string, string> = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
  };

  /**
   * Stringify JSON with pretty formatting
   */
  static stringify(data: JSONObject | null): string {
    if (!data) {
      return "";
    }
    return JSON.stringify(data, null, this.INDENT_SPACES);
  }

  /**
   * Safely parse JSON string
   */
  static parse(str: string): JSONObject | null {
    try {
      return JSON.parse(str) as JSONObject;
    } catch {
      return null;
    }
  }

  /**
   * Apply syntax highlighting to JSON string
   * Returns HTML string with span elements for each token type
   */
  static syntaxHighlight(json: string, styles: Record<string, string>): string {
    const pattern = /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g;

    return this.escapeHtml(json).replace(pattern, (match) => {
      let className = styles.jsonNumber;

      if (/^"/.test(match)) {
        className = /:$/.test(match) ? styles.jsonKey : styles.jsonString;
      } else if (/true|false/.test(match)) {
        className = styles.jsonBoolean;
      } else if (/null/.test(match)) {
        className = styles.jsonNull;
      }

      return `<span class="${className}">${match}</span>`;
    });
  }

  private static escapeHtml(value: string): string {
    return value.replace(/[&<>]/g, (char) => this.HTML_ESCAPES[char]);
  }
}
